module.exports = __webpack_public_path__ + "static/img/2859_phase_function_Paper_PointsHejduk_Prediction.08fe14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2859_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SZlF
// module chunks = 0